const items = [
  "Rituels ancestraux d'Afrique",
  "Retour de l'être aimé",
  "Cible totalement maîtrisée",
  "Promotion & protection au travail",
  "Tarif unique 150€ après satisfaction",
  "Confidentialité totale",
  "Si pas de résultat, vous ne payez pas",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {items.map((t) => (
      <span key={t} className="flex items-center whitespace-nowrap">
        <span className="font-serif-it px-8 text-3xl italic text-amber-100 md:text-5xl">{t}</span>
        <svg width="18" height="18" viewBox="0 0 20 20" className="text-amber-500" aria-hidden="true">
          <polygon points="10,0 12.5,7.5 20,10 12.5,12.5 10,20 7.5,12.5 0,10 7.5,7.5" fill="currentColor" />
        </svg>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div className="relative overflow-hidden border-y border-amber-900/40 bg-[#12100e] py-6 md:py-8" data-testid="editorial-marquee">
    <div className="marquee-track flex w-max">
      <Row />
      <Row />
    </div>
  </div>
);
